import { axiosInstance } from "../axios";
import {  category_apis } from "../ApiConst";


export const categories = async () => {
  // const token = "9i8h7g6f-5e4d-3c2b-1a0j-dcba098765fe";
  try {
    const response = await axiosInstance.get(category_apis.categories);
    return response;
  } catch (error) {
    throw new Error(error);
  }
};


export const Sub_categories = async (id) => {
  // const token = "9i8h7g6f-5e4d-3c2b-1a0j-dcba098765fe";
  try {
    const response = await axiosInstance.get(category_apis.sub_categories(id));
    return response;
  } catch (error) {
    throw new Error(error);
  }
};
